import { render, staticRenderFns } from "./SendForm.vue?vue&type=template&id=1eefafe9&scoped=true"
import script from "./SendForm.vue?vue&type=script&lang=js"
export * from "./SendForm.vue?vue&type=script&lang=js"
import style0 from "./SendForm.vue?vue&type=style&index=0&id=1eefafe9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eefafe9",
  null
  
)

export default component.exports